export const WithdrawalEnum = {
    Methods:0,
    History:1
}

Object.freeze(WithdrawalEnum);


export default WithdrawalEnum;